// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","266":"2c796e83","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"dcf8c610add7dc50580a","266":"218f475be095f659d2d3","293":"2d24e4f1f6ec175b4e2c"}[chunkId] + ".js";
};